import Immutable from 'immutable';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { getFormValues, reduxForm } from 'redux-form/immutable';

// actions creators
import {
  appointmentListClear,
  appointmentShow,
  appointmentUpdate
} from '../../../actions/appointmentActions';
import { booksFetchCaterers, booksShow } from '../../../actions/booksActions';
import { doctorAvailabilitiesClear, doctorAvailabilitiesFetchForOffice } from '../../../actions/doctorActions';
import { tooltipShow } from '../../../actions/tooltipActions';
import { destroy, initialize } from 'redux-form/immutable';

// components
import ConfirmCancelAppointmentModal from './_ConfirmCancelAppointmentModal';
// import ConfirmTradePostingModal from './_ConfirmTradePostingModal';
// import AlreadyPostedModal from './_AlreadyPostedModal';
import { Link } from 'react-router';
import { Field } from 'redux-form/immutable';
import { Button } from '../../shared/_form';
import { Panel, PanelBody, PanelHeader } from '../../shared/_panel';
import Spinner from '../../shared/_Spinner';

// constants
const FORM_NAME = 'appointmentCaterer';

// lib
import formatPhoneNumber from '../../../lib/formatPhoneNumber';
import  AppointmentDetailsItem  from './AppointmentDetailsItem';
import Advertisement from '../../shared/_advertisement';

class Show extends React.Component {
  static propTypes = {
    appointment:                PropTypes.instanceOf(Immutable.Map),
    books:                      PropTypes.instanceOf(Immutable.Map),
    clearAppointments:          PropTypes.func.isRequired,
    clearDoctorAvailabilities:  PropTypes.func.isRequired,
    clearForm:                  PropTypes.func.isRequired,
    currentUser:                PropTypes.instanceOf(Immutable.Map),
    doctor:                     PropTypes.instanceOf(Immutable.Map),
    doctorAvailabilities:       PropTypes.instanceOf(Immutable.Map),
    fetchCaterers:              PropTypes.func.isRequired,
    fetchDoctorAvailability:    PropTypes.func.isRequired,
    formValues:                 PropTypes.instanceOf(Immutable.Map),
    updateAppointment:          PropTypes.func.isRequired
  };

    state = {
      modalHandleActionType: ''
    };

    componentWillMount() {
      const { params: { date, id } } = this.props;
      const appointment = ((this.props.appointment.get('data') || Immutable.Map()).get(date) || Immutable.Map()).get(id) || Immutable.Map();
      const officeId    = appointment.get('office');

      if (appointment.size === 0) {
        this._initAppointment(this.props);
      }
      if (officeId) {
        this._initCaterers(officeId);
        this._initDoctorAvailability(officeId);
      }
    }

    componentDidUpdate(prevProps) {
      const { params: { date, id } } = prevProps;
      const currentAppointment  = ((this.props.appointment.get('data') || Immutable.Map()).get(date) || Immutable.Map()).get(id) || Immutable.Map();
      const currentOfficeId     = currentAppointment.get('office') || Immutable.Map();
      const prevAppointment     = ((prevProps.appointment.get('data') || Immutable.Map()).get(date) || Immutable.Map()).get(id) || Immutable.Map();
      const prevOfficeId        = prevAppointment.get('office') || Immutable.Map();

      const currentBook        = (this.props.books.get('data') || Immutable.Map()).get(currentAppointment.get('office')) || Immutable.Map();
      const prevBook        = (prevProps.books.get('data') || Immutable.Map()).get(prevOfficeId) || Immutable.Map();

      if (this.props.books.size === 0 && currentAppointment.get('office')) {
        const params = {
          id: currentAppointment.get('office')
        };

        this.props.showBook(params);
      }

      if (prevBook.get('id') !== currentBook.get('id') && currentAppointment.get('office')) {
        this._initCaterers(currentAppointment.get('office'));
        this._initDoctorAvailability(currentOfficeId);
      }

      if (currentAppointment.get('caterer')) {
        this._initForm(currentAppointment);
      }
    }

    componentWillUnmount() {
      const { clearDoctorAvailabilities, clearAppointments, clearForm } = this.props;

      clearDoctorAvailabilities();
      clearAppointments();
      clearForm();
    }

    render() {
      const { books, params: { date, id } } = this.props;
      const { modalHandleActionType } = this.state;
      const appointment = ((this.props.appointment.get('data') || Immutable.Map()).get(date) || Immutable.Map()).get(id) || Immutable.Map();
      const book        = (books.get('data') || Immutable.Map()).get(appointment.get('office')) || Immutable.Map();
      const scheduledOn = moment(appointment.get('scheduledOn'), 'YYYY-MM-DD').startOf('day').add(appointment.get('from'), 'seconds');
      const loading = this.props.appointment.get('loading') || books.get('loading');

      return (
        <div className='body__content body__content--center rep-apts-show'>
          { this._renderHeaderDate(date) }

          <Spinner className='rep-apts-show__content' enabled={ loading }>
            <Panel>
              <Advertisement />
              <PanelHeader className='rep-apts-show__header panel__header'>
                <Link to='/reps/calendar'>
                  <i className='fa fa-chevron-left rep-apts-show__header__back-button' />
                </Link>
                { `${scheduledOn.format('H:mm A')} at ${book.get('name')}` }
              </PanelHeader>
              <PanelBody className='rep-apts-show__body'>
                {this._renderDetailsContent(scheduledOn, book, appointment)}
              </PanelBody>
            </Panel>
          </Spinner>
          <ConfirmCancelAppointmentModal appointmentId={ appointment.get('id') }
            id={ `cancelAppointmentModal${appointment.get('id')}` }
            type={ modalHandleActionType } />
          {/* <ConfirmTradePostingModal appointmentId={ appointment.get('id') }
            id={ `postTradeAppointmentModal${appointment.get('id')}` } />
          <AlreadyPostedModal id={ `alreadyPostedModal${appointment.get('id')}` } /> */}
        </div>
      );
    }

  // private

  // _handleShowTradeAppointmentModal = () => {
  //   const { dispatch, params: { date, id } } = this.props;
  //   const appointment = ((this.props.appointment.get('data') || Immutable.Map()).get(date) || Immutable.Map()).get(id) || Immutable.Map();

  //   if (appointment.get('alreadyPostedOffer')) {
  //     dispatch(tooltipShow({ id: `alreadyPostedModal${appointment.get('id')}` }));
  //   } else {
  //     dispatch(tooltipShow({ id: `postTradeAppointmentModal${appointment.get('id')}` }));
  //   }
  // }

  _handleShowCancelAppointmentModal = (type) => () => {
    const { dispatch, params: { date, id } } = this.props;

    this.setState({ modalHandleActionType: type });
    const appointment = ((this.props.appointment.get('data') || Immutable.Map()).get(date) || Immutable.Map()).get(id) || Immutable.Map();

    dispatch(tooltipShow({ id: `cancelAppointmentModal${appointment.get('id')}` }));
  };

  _handleSubmit = (e) => {
    e.preventDefault();

    const { formValues, params: { id }, updateAppointment } = this.props;

    const caterer = formValues.getIn(['caterer', 'name']);

    updateAppointment({ id: id, caterer: caterer });
  };

  _initAppointment(props) {
    const { showAppointment, params: { id } } = props;

    const params = {
      id
    };

    showAppointment(params);
  }

  _initCaterers(officeId) {
    const { fetchCaterers } = this.props;

    fetchCaterers({ officeId: officeId });
  }

  _initDoctorAvailability(officeId) {
    const { fetchDoctorAvailability, params: { date } } = this.props;

    fetchDoctorAvailability({
      officeId:     officeId,
      'start_date': moment(date, 'YYYY-MM-DD').startOf('day').format(),
      'end_date':   moment(date, 'YYYY-MM-DD').endOf('day').format()
    });
  }

  _initForm(appointment) {
    const { dispatch } = this.props;

    const caterer = appointment.get('caterer');

    dispatch(initialize(FORM_NAME, { caterer: caterer }, { keepDirty: true }));
  }

  _isFormLoading() {
    const { appointment } = this.props;

    return appointment.get('loading');
  }

  _renderCaterers() {
    const { books, params: { date, id } } = this.props;

    const appointment = ((this.props.appointment.get('data') || Immutable.Map()).get(date) || Immutable.Map()).get(id) || Immutable.Map();
    const book        = (books.get('data') || Immutable.Map()).get(appointment.get('office')) || Immutable.Map();
    const caterers    = (book.get('caterers') || Immutable.List()).map((caterer) => {
      return caterer.get('name');
    });

    let element = null;

    if (caterers.size > 0) {
      element = `Last ${caterers.size} caterers: ${caterers.join(', ')}`;
    } else {
      element = 'No previous caterers';
    }

    return element;
  }

  _renderDoctors() {
    const { doctor, doctorAvailabilities, params: { date } } = this.props;

    const availabilities = (doctorAvailabilities.get('data') || Immutable.Map()).get(date) || Immutable.Map();
    const doctorData     = (doctor || Immutable.Map()).get('data') || Immutable.Map();
    const elements       = [];

    availabilities.forEach((availability) => {
      const d = doctorData.get(availability.get('doctor'));

      elements.push(d.get('name'));
    });

    return elements.join(', ');
  }

  _renderHeaderDate(date) {
    const scheduledOn = moment(date, 'YYYY-MM-DD');

    let label;

    if (date) {
      label = `${scheduledOn.format('MMM D')}: Details`;
    }

    return (<PanelHeader className={ 'panel__header--appointment-details' }>{ label }</PanelHeader>);
  }

  _renderDetailsContent = (scheduledOn, book, appointment) => ({
    cancelled: (
      <React.Fragment>
        <AppointmentDetailsItem label={ 'Details' }>
          <div>{ `${scheduledOn.format('MMMM D, YYYY')} at ${scheduledOn.format('H:mm A')}` }</div>
          <div>{ book.get('address') }</div>
          <div>{ `${book.get('city')}, ${book.get('state')} ${book.get('postalCode')}` }</div>
          <div>{ formatPhoneNumber(book.get('phoneNumber')) }</div>
        </AppointmentDetailsItem>
        <AppointmentDetailsItem label={ 'Doctor' }>
          <div>{ this._renderDoctors() }</div>
        </AppointmentDetailsItem>
        <AppointmentDetailsItem label={ 'Notes From Office' }>
          <div className={ 'rep-apts-notes--text' }>{ appointment.get('notes') }</div>
        </AppointmentDetailsItem>
        <AppointmentDetailsItem label={ 'Catering' }>
          <div>{ this._renderCaterers() }</div>
        </AppointmentDetailsItem>
      </React.Fragment>
    ),
    booked: (
      <React.Fragment>
        <AppointmentDetailsItem label={ 'Details' }>
          <div>{ `${scheduledOn.format('MMMM D, YYYY')} at ${scheduledOn.format('H:mm A')}` }</div>
          <div>{ book.get('address') }</div>
          <div>{ `${book.get('city')}, ${book.get('state')} ${book.get('postalCode')}` }</div>
          <div>{ formatPhoneNumber(book.get('phoneNumber')) }</div>
        </AppointmentDetailsItem>
        <AppointmentDetailsItem label={ 'Doctor' }>
          <div>{ this._renderDoctors() }</div>
        </AppointmentDetailsItem>
        <AppointmentDetailsItem label={ 'Notes From Office' }>
          <div className={ 'rep-apts-notes--text' }>{ appointment.get('notes') }</div>
        </AppointmentDetailsItem>
        <AppointmentDetailsItem label={ 'Catering' }>
          <div>{ this._renderCaterers() }</div>
        </AppointmentDetailsItem>
        <form className='form' onSubmit={ this._handleSubmit }>
          <AppointmentDetailsItem label={ 'Caterer' }>
            <Field className='form__field form__field--rounded rep-apts-show__form__field' component='input' name='caterer.name' placeholder={ 'Please indicate a caterer' } type='text' />
          </AppointmentDetailsItem>
          <div className='rep-apts-show__form-submit'>
            <Button className='form__button form__button--red rep-apts-show__button' disabled={ this._isFormLoading() } onClick={ this._handleShowCancelAppointmentModal('cancel') } type='button'>Cancel Appt.</Button>
            {/* <Button className={ `form__button form__button--${appointment.get('alreadyPostedOffer') ? 'grey' : 'purple'} rep-apts-show__button` } loading={ this._isFormLoading() } onClick={ this._handleShowTradeAppointmentModal } type='button'>Trade this</Button> */}
            <Button className='form__button form__button--blue rep-apts-show__button' loading={ this._isFormLoading() } onClick={ this._handleShowCancelAppointmentModal('confirm') } type='button'>confirm appt.</Button>
            <Button className='form__button form__button--green rep-apts-show__button' loading={ this._isFormLoading() } type='submit'>Save</Button>
          </div>
        </form>
      </React.Fragment>
    ),
    confirmed: (
      <React.Fragment>
        <AppointmentDetailsItem label={ 'Details' }>
          <div>{ `${scheduledOn.format('MMMM D, YYYY')} at ${scheduledOn.format('H:mm A')}` }</div>
          <div>{ book.get('address') }</div>
          <div>{ `${book.get('city')}, ${book.get('state')} ${book.get('postalCode')}` }</div>
          <div>{ formatPhoneNumber(book.get('phoneNumber')) }</div>
        </AppointmentDetailsItem>
        <AppointmentDetailsItem label={ 'Doctor' }>
          <div>{ this._renderDoctors() }</div>
        </AppointmentDetailsItem>
        <AppointmentDetailsItem customLabelStyle={ 'rep-apts-notes--label' } label={ 'Notes From Office' }>
          <div className={ 'rep-apts-notes--text' }>{ appointment.get('notes') }</div>
        </AppointmentDetailsItem>
        <AppointmentDetailsItem label={ 'Catering' }>
          <div>{ this._renderCaterers() }</div>
        </AppointmentDetailsItem>
        <form className='form' onSubmit={ this._handleSubmit }>
          <AppointmentDetailsItem label={ 'Caterer' }>
            <Field className='form__field form__field--rounded rep-apts-show__form__field' component='input' name='caterer.name' placeholder={ 'Please indicate a caterer' } type='text' />
          </AppointmentDetailsItem>
          <div className='rep-apts-show__form-submit'>
            <Button className='form__button form__button--red rep-apts-show__button' disabled={ this._isFormLoading() } onClick={ this._handleShowCancelAppointmentModal('cancel') } type='button'>Cancel Appt.</Button>
            {/* <Button className={ `form__button form__button--${appointment.get('alreadyPostedOffer') ? 'grey' : 'purple'} rep-apts-show__button` } loading={ this._isFormLoading() } onClick={ this._handleShowTradeAppointmentModal } type='button'>Trade this</Button> */}
            <Button className='form__button form__button--green rep-apts-show__button' loading={ this._isFormLoading() } type='submit'>Save</Button>
          </div>
        </form>
      </React.Fragment>
    )
  }[appointment.get('status')])
}

const mapStateToProps = (state) => {
  return {
    appointment:          state.get('appointment'),
    books:                state.get('books'),
    currentUser:          state.get('currentUser'),
    doctor:               state.get('doctor'),
    doctorAvailabilities: state.get('doctorAvailabilities'),
    formValues:           getFormValues(FORM_NAME)(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearDoctorAvailabilities: () => {
      dispatch(doctorAvailabilitiesClear());
    },

    clearAppointments: () => {
      dispatch(appointmentListClear());
    },

    clearForm: () => {
      dispatch(destroy(FORM_NAME));
    },

    showAppointment: (params) => {
      dispatch(appointmentShow(params));
    },

    showBook: (params) => {
      dispatch(booksShow(params));
    },

    fetchCaterers: (params) => {
      dispatch(booksFetchCaterers(params));
    },

    fetchDoctorAvailability: (params) => {
      dispatch(doctorAvailabilitiesFetchForOffice(params));
    },

    updateAppointment: (params) => {
      dispatch(appointmentUpdate(params));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm(
    { form: FORM_NAME }
  )(Show)
);



// WEBPACK FOOTER //
// ./app/components/reps/appointments/Show.jsx